import React from 'react';
import { Seo } from '../components/Seo';
import { ButtonLink, Eyebrow, Heading, NextPage, Prose, Section, TextLink } from '../components/ui';
import { images, site } from '../data/site';
const doelgroepen = [{
  title: 'Particuliere klanten',
  text: 'Mensen die één goede portemonnee, pasjeshouder of riem zoeken en daar vervolgens jaren mee vooruit willen. De keuze gaat meestal over indeling en formaat: hoeveel pasjes, wel of geen muntvak, en past het comfortabel in de zak of tas.'
}, {
  title: 'Horeca',
  text: 'Bedienend personeel werkt met bonnen, briefgeld, munten, pen en telefoon tegelijk. Kelnerportemonnees en holsters zijn daarop ingedeeld, met vakken die tijdens een drukke dienst blindelings te vinden zijn.'
}, {
  title: 'Taxibedrijven',
  text: 'In het taxivervoer wisselen contant geld, bonnetjes en pasjes voortdurend van hand. Een compacte leren portemonnee of etui met een duidelijke indeling voorkomt zoekwerk tijdens een rit.'
}, {
  title: 'Kappers',
  text: 'In een kapsalon is het praktisch om schaar, kam, pen en betaalmiddelen bij de hand te houden. Leren heuptasjes en etuis zijn daarvoor bruikbaar, ook omdat leer dagelijks gebruik goed verdraagt.'
}];
export function OverOns() {
  return <>
      <Seo title="Over LeonDesign | Lederwarenspecialist uit Geleen, Limburg" description="Lees wie LeonDesign is: een lederwarenspecialist uit Geleen met naar eigen zeggen ruim 25 jaar ervaring in leer, voor particulieren, horeca, taxi en kappers." data-id="element-393" data-mp="2u320gbyudrj9" />

      <Section className="pt-12 sm:pt-16" data-id="element-394" data-mp="343cc3s58aqwb">
        <div className="max-w-3xl" data-id="element-395" data-mp="382utwf1r6lux">
          <Eyebrow data-id="element-396" data-mp="383w6inyf3ger">Over ons</Eyebrow>
          <h1 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-397" data-mp="3d1xpl8vuffq8">
            Een specialist in leer, gevestigd in Geleen
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-cocoa/90" data-id="element-398" data-mp="1drg2ltt3ged2">
            LeonDesign is een Nederlandse webshop in lederwaren. Het bedrijf richt zich op leren
            portemonnees, horeca lederwaren en kleine leren accessoires, en levert zowel aan
            particulieren als aan professionele gebruikers.
          </p>
        </div>

        <figure className="mt-10 overflow-hidden rounded-3xl border border-cocoa/10 bg-paper" data-id="element-399" data-mp="2v0tldm4lgas0">
          <img src={images.cover} alt="Assortiment leren portemonnees, pasjeshouders en paspoorthoesjes van LeonDesign" className="w-full object-cover" width={1600} height={600} data-id="element-400" data-mp="2pzmedpa9zfme" />
          <figcaption className="px-6 py-4 text-sm text-cocoa/70" data-id="element-401" data-mp="2zx0ufnsae2e6">
            Een doorsnede van het assortiment: portemonnees, pasjeshouders en paspoorthoesjes in
            verschillende leersoorten en kleuren.
          </figcaption>
        </figure>
      </Section>

      <Section className="pt-20 sm:pt-24" data-id="element-402" data-mp="3noxtsfejv1ye">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-403" data-mp="3ipla23iz6b01">
          <div data-id="element-404" data-mp="3in8l36esv0dh">
            <Eyebrow data-id="element-405" data-mp="65qycp3haw7l">Achtergrond</Eyebrow>
            <Heading data-id="element-406" data-mp="66s88q8rdcnq">Ruim 25 jaar bezig met hetzelfde materiaal</Heading>
          </div>
          <Prose data-id="element-407" data-mp="b53mdd6369br">
            <p data-id="element-408" data-mp="b3iszqvicwfh">
              LeonDesign geeft aan meer dan 25 jaar ervaring te hebben als specialist in leer. Zo’n
              periode levert vooral één ding op: een goed beeld van wat er in de praktijk misgaat.
              Welke sluiting na een half jaar niet meer pakt, welke naad als eerste opgeeft, welke
              indeling in theorie logisch lijkt maar in het dagelijks gebruik niet werkt. Die kennis
              bepaalt de samenstelling van de collectie.
            </p>
            <p data-id="element-409" data-mp="39nikvnyuinye">
              Het bedrijf werkt vanuit Geleen, in de gemeente Sittard-Geleen in Limburg. De
              bestellingen lopen via de webshop, die 24 uur per dag bereikbaar is. Wie liever eerst
              overlegt, kan bellen of e-mailen; de{' '}
              <TextLink to="/contact" data-id="element-410" data-mp="34n4ox4air4gq">contactgegevens en het adres</TextLink> staan overzichtelijk op
              de contactpagina.
            </p>
            <p data-id="element-411" data-mp="2xjmzil69uv2w">
              Op deze informatiesite worden geen prijzen of voorraden getoond. Het doel is dat u
              begrijpt welk type leren artikel bij uw situatie past, zodat u daarna gerichter kunt
              kiezen.
            </p>
          </Prose>
        </div>
      </Section>

      <Section className="pt-20 sm:pt-24" data-id="element-412" data-mp="2iuidsu09q8q1">
        <div className="rounded-3xl bg-sand/70 p-7 sm:p-12" data-id="element-413" data-mp="2etoru66dz3zs">
          <div className="grid gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-414" data-mp="2ev9n5y0iyqyp">
            <div data-id="element-415" data-mp="29uc65or942ys">
              <Eyebrow data-id="element-416" data-mp="29tsom95ijgla">Productfilosofie</Eyebrow>
              <Heading data-id="element-417" data-mp="24visnwbysbym">Functioneel eerst, en dan pas mooi</Heading>
              <Prose className="mt-5" data-id="element-418" data-mp="24vr6bqfwvlav">
                <p data-id="element-419" data-mp="1zwnyjy8jr0z7">
                  De producten van LeonDesign combineren functionaliteit met een stijlvol en tijdloos
                  ontwerp. Dat betekent in de praktijk dat de indeling het uitgangspunt is: hoeveel
                  pasjes moeten erin, hoe vaak gaat het artikel open, wordt het gedragen aan een riem
                  of in een binnenzak.
                </p>
                <p data-id="element-420" data-mp="6k8t7ziv4nob">
                  Pas daarna komt de vormgeving aan bod, en die is bewust ingetogen. Een portemonnee
                  of riem die nu opvalt door een modedetail, valt over drie jaar vooral op omdat het
                  detail gedateerd is. Rustige lijnen en een goede afwerking blijven bruikbaar.
                </p>
              </Prose>
            </div>
            <div data-id="element-421" data-mp="3juem64g96a7m">
              <Eyebrow data-id="element-422" data-mp="3juy3pk1zqwl4">Locatie</Eyebrow>
              <Heading data-id="element-423" data-mp="3ntf2ngb9d0rg">Geleen als thuisbasis</Heading>
              <Prose className="mt-5" data-id="element-424" data-mp="3nw9o9b60crmg">
                <p data-id="element-425" data-mp="3st0cwmvvovjh">
                  Het adres is {site.street}, {site.postal} {site.city}. Geleen ligt in
                  Zuid-Limburg, op korte afstand van Sittard, Beek en Stein, en dicht bij de Duitse
                  en Belgische grens. Voor bezoekers uit de regio is dat prettig; voor de rest van
                  Nederland verloopt alles via de webshop.
                </p>
                <p data-id="element-426" data-mp="ndq9smab92pb">
                  Zoekt u lederwaren in Geleen of omgeving, dan vindt u de vermeldingen van het
                  bedrijf ook terug op diverse externe platforms. Een geordend overzicht daarvan
                  staat op de <TextLink to="/bronnen" data-id="element-427" data-mp="xb4qmn05bti5">bronnenpagina</TextLink>.
                </p>
              </Prose>
            </div>
          </div>
        </div>
      </Section>

      <Section className="pt-20 sm:pt-24" data-id="element-428" data-mp="4n8upkiei5mf">
        <div className="max-w-2xl" data-id="element-429" data-mp="4oa3tjfuwi1i">
          <Eyebrow data-id="element-430" data-mp="4l5sm23z4m1c">Voor wie</Eyebrow>
          <Heading data-id="element-431" data-mp="3vul2xa1b38q7">Particuliere en professionele gebruikers</Heading>
          <p className="mt-4 text-[17px] leading-relaxed text-cocoa/85" data-id="element-432" data-mp="edbmxihp7fjp">
            LeonDesign bedient consumenten, horecaprofessionals, taxibedrijven en kappers. Die
            groepen stellen deels dezelfde eisen aan leer, maar gebruiken het op een heel andere
            manier.
          </p>
        </div>
        <div className="mt-10 grid gap-x-12 gap-y-9 md:grid-cols-2" data-id="element-433" data-mp="3d3k20ggml340">
          {doelgroepen.map(d => <div key={d.title} className="border-t border-cocoa/15 pt-6" data-id="element-434" data-mp="1skrgd9hvk2ly">
              <h3 className="font-display text-xl font-semibold text-ink" data-id="element-435" data-mp="1xbzq66n49pzn">{d.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-cocoa/85" data-id="element-436" data-mp="1xdszxut10qbv">{d.text}</p>
            </div>)}
        </div>
      </Section>

      <Section className="pt-20 sm:pt-24" data-id="element-437" data-mp="1nlesclf9ophs">
        <div className="grid items-center gap-10 rounded-3xl border border-cocoa/12 bg-paper p-6 sm:p-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14" data-id="element-438" data-mp="1nk3sgwoy01vy">
          <div data-id="element-439" data-mp="2gbdof0rvpmvy">
            <Eyebrow data-id="element-440" data-mp="2g9svtgp4ke0q">Het aanbod in het kort</Eyebrow>
            <Heading data-id="element-441" data-mp="2g8hoj6wh0o4v">Wat u bij LeonDesign vindt</Heading>
            <Prose className="mt-5" data-id="element-442" data-mp="22ab16kp5e6jg">
              <p data-id="element-443" data-mp="22dfafwhgzsgz">
                De collectie bestaat uit portemonnees, pasjeshouders, sleuteletuis, heuptasjes,
                riemen, paspoorthoesjes, pennenzakken en horeca accessoires. Binnen elke groep zijn
                er verschillen in formaat, indeling en leersoort, zodat er zowel iets is voor wie
                alleen pasjes meeneemt als voor wie de hele dag met contant geld werkt.
              </p>
              <p data-id="element-444" data-mp="1hm92v80jb7jk">
                Per productgroep leest u op de{' '}
                <TextLink to="/collectie" data-id="element-445" data-mp="1ho3sgzmr3ntz">collectiepagina</TextLink> waar het artikel voor bedoeld
                is en wie er baat bij heeft.
              </p>
            </Prose>
            <div className="mt-7 flex flex-wrap gap-3" data-id="element-446" data-mp="18mvukio5cp0f">
              <ButtonLink to="/collectie" data-id="element-447" data-mp="25c3ejm94aq28">Naar de collectie</ButtonLink>
              <ButtonLink to="/contact" variant="secondary" data-id="element-448" data-mp="25demzzdiclzo">
                Stel uw vraag
              </ButtonLink>
            </div>
          </div>
          <figure className="overflow-hidden rounded-2xl" data-id="element-449" data-mp="1wi8cwo77fhrc">
            <img src={images.horecaTerras} alt="Leren horeca lederwaren van LeonDesign met een bediening op een terras" className="h-full w-full object-cover" width={1024} height={1536} loading="lazy" data-id="element-450" data-mp="1rkf5jru60hph" />
          </figure>
        </div>
      </Section>

      <Section className="pt-16" data-id="element-451" data-mp="2rlah69ueu4nc">
        <div className="grid gap-4 md:grid-cols-3" data-id="element-452" data-mp="2rmbukkywf388">
          <NextPage to="/" label="Terug naar de homepage" description="Overzicht van de productgroepen en van wat LeonDesign onderscheidt." data-id="element-453" data-mp="2wk4z79kjzp6e" />
          <NextPage to="/bronnen" label="Bronnen & vermeldingen" description="Externe profielen en kaartdiensten waarop het bedrijf te vinden is." data-id="element-454" data-mp="35k0enql566c8" />
          <NextPage to="/contact" label="Contactgegevens" description="Adres in Geleen, telefoon, e-mail en openingstijden van de webshop." data-id="element-455" data-mp="3fh6835h8a9fm" />
        </div>
      </Section>
    </>;
}